import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faJava, faPython, faAngular } from '@fortawesome/free-brands-svg-icons';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "Angular 18 & 21",
    "Spring Boot",
    "Spring Framework",
    "Java",
    ".NET 10",
    "TypeScript",
    "JavaScript",
    "SQL",
    "PostgreSQL",
    "HTML5",
    "CSS3",
    "REST APIs",
    "Postman",
];

const labelsThird = [
    "Python",
    "TensorFlow",
    "Keras",
    "NumPy",
    "Pandas",
    "Deep Learning",
    "Machine Learning",
    "Image Processing",
    "RAG",
    "LLMs",
    "OpenCV",
    "NLP",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid skills-grid-2">

                <div className="skill">
                    <FontAwesomeIcon icon={faAngular} size="3x" className="icon-gap"/>
                    <FontAwesomeIcon icon={faJava} size="3x"/>
                    <h3>Full Stack Web Development</h3>
                    <p>An engineer specialising in full-stack development, I design and build comprehensive software solutions encompassing both front-end and back-end components — leveraging Angular for dynamic user interfaces and Spring Boot with .NET for robust, scalable back-end systems used by enterprise clients globally.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        <div className="chip-group">
                            {labelsFirst.map((label, index) => (
                                <span key={index} className="tech-chip">{label}</span>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>GenAI &amp; LLM</h3>
                    <p>I have worked extensively with neural networks, deep learning, and imaging technologies across research and production projects. My experience spans building OCR engines, RAG pipelines, and AI models published in IEEE and Springer Nature journals — translating research into real-world systems.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        <div className="chip-group">
                            {labelsThird.map((label, index) => (
                                <span key={index} className="tech-chip">{label}</span>
                            ))}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    );
}

export default Expertise;
